<lib-generic-type-ahead-dropdown
    [(selectedItem)]="selectedContact"
    placeholder="Add Contact"
    (selectedItemChange)="onContactChange($event)"
    [(text)]="searchText"
    [source]="source"
    [displaySelected]="displaySelected"
    (textChange)="onContactTextChanged()"
    [config]="{
        defaultText: 'Contact',
        itemDisplayKey: 'fullName',
        itemTemplate: contactTemplate,
        isActive: selectedContact?.isActive ?? true,
        clearSelection: selectedContact?.id ? true : false
    }"
    [isReadOnly]="isReadOnly"
    [action]="addContactAction"
    [path]="path()"
>
</lib-generic-type-ahead-dropdown>

<ng-template #contactTemplate let-data>
    <app-custom-menu-item
        [inputText]="data.inputText"
        [title]="
            $safeNavigationMigration(data.object?.firstName) + ' ' + $safeNavigationMigration(data.object?.lastName)
        "
        [subtitle]="data.object?.companyName ?? 'No company assigned'"
    >
    </app-custom-menu-item>
</ng-template>
